import { FormSelector, IOption } from '../../../../../base';
import { FilterContainer } from './DropdownFilter.styles';
import { Control, FieldValues } from 'react-hook-form';

interface Props {
    title: string;
    options: Array<IOption>;
    name: string;
    control: Control<FieldValues>;
}

const DropdownFilter = ({ title, options, name, control }: Props) => {
    return (
        <FilterContainer>
            <FormSelector
                name={name}
                control={control}
                options={options}
                label={title}
            />
        </FilterContainer>
    );
};

export default DropdownFilter;
